var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({staticClass:"icon",on:{"click":_vm.click}},'img',{ src: _vm.src, alt: _vm.alt, title: _vm.title },false))}
var staticRenderFns = []

export { render, staticRenderFns }